<template>
  <div>
    <v-card-title class="py-1 mb-2 mx-3" style="border-bottom: 1px dashed #666;">Location</v-card-title>
    <v-autocomplete
    hide-details
      class="pb-0"
      v-model="locations"
      :items="getlocations"
      item-text="fullName"
      id="locationID"
      label="Location"
      multiple
      dense
      chips
      small-chips
      deletable-chips
      return-object
      outlined>
      <template v-slot:item="data">
        <v-list-item-content>
          <v-list-item-title>
              <v-badge
                :content="data.item.count"
                inline
                color="primary"
              >
                {{data.item.fullName}}
              </v-badge>
          </v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
import {findAgg} from  "@/utils/helpers"

export default {
  name: 'locationSearch',
  components: {
  },
  props: {
    prefix:"",
    aggregations:{},
    locationsPreSet: {
      type: Array,
      default: function () {
        return []
      },
    },
    locationFacets: {
      type: Array,
      default: function () {
        return []
      },
    },
    setLocations:Function
  },
  data () {
    return {
      update:false,
      locations: this.locationsPreSet
    }
  },
  computed: {
    getlocations(){
      if (this.$store.state.locations === 0){
        this.$store.dispatch('getLocations')
      }
      var locations = []
      for (let location of this.$store.state.locations){
        location["fullName"] = location.name
        if (location.town){
          location["fullName"] += ", " + location.town
        }
        if (location.country){
          location["fullName"] += ", " + location.country
        }
        if (this.aggregations){
          location["count"] = findAgg(this.aggregations, location.locationID)
        }
        if (location.count > 0){
          locations.push(location)
        }
      }
      return locations
    },
  },
  methods: {
    removeFilter(filter){
      this.$log.debug("removeFilter in caveSearch", filter);
      this.locations.splice(this.locations.indexOf(filter.locationID), 1);
    },

    clear(){
      this.update = false
      this.locations = [];
    },
    prepSearch(){
      console.log("prepSearch location", this.locations);

      let searchObjects = []
      let aggsObject = {}
      let locationPath = this.prefix + "locationID"
      aggsObject["location"] = {
        "field" :  locationPath
      }
      if (this.locations.length > 0){
        let locationIDs = []
        for (let location of this.locations){
          locationIDs.push(location.locationID)
        }
        let locationSearch = {
          "terms": {
          }
        }
        locationSearch.terms[locationPath] = locationIDs
        aggsObject["location"]["ids"] = locationIDs
        searchObjects.push(locationSearch)
      }
      let result = {}
      result['search'] = searchObjects
      result['aggs'] = aggsObject

      result["activeFilter"] = {
        "location": this.locations
      }
      this.$log.debug("searchObject of location", result);
      return result
    },
    startSearch(){
      let result = this.prepSearch()
      this.$emit('clicked', result)
    },
  },
  watch: {
    'locations': function(newVal, oldVal) {
      console.log("locations changed! filtertree", newVal, this.update);
      this.startSearch()
    },
    'aggregations': function(newVal, oldVal) {
      this.$log.debug("updated aggregations on location", this.aggregations);
    },

  },
  mounted:function () {
    this.locations = this.locationsPreSet
  },
  beforeUpdate:function () {
  }
}
</script>

<style lang="css" >
</style>
